import { Check } from '@insify/design-system/icons';
import { textMdSemibold, textSm, textSmSemibold } from '@insify/design-system/typography';
import { TrackedAnchor } from '@objectiv/tracker-react';
import clsx from 'clsx';

import * as styles from './PartnerDeals.module.css';

export type PartnerDeal = {
  identifier: string;
  Image: React.ComponentType<{ alt: string; className?: string }>;
  heading: string;
  description: string;
  cta: string;
  link: string;
};

export const PartnerDeals = ({ className, partnerDeals }: { className?: string; partnerDeals: PartnerDeal[] }) => {
  return (
    <div className={className}>
      {partnerDeals.map((deal) => (
        <div key={deal.identifier} className={styles.card}>
          <deal.Image alt={deal.heading} className={styles.img} />
          <div className={styles.content}>
            <span className={clsx(textMdSemibold, styles.heading)}>{deal.heading}</span>
            <p className={clsx(textSm, styles.description)}>{deal.description}</p>
            <span className={clsx(textSmSemibold, styles.link)}>
              <Check className={styles.check} />
              <TrackedAnchor id={deal.identifier} href={deal.link} target='_blank' rel='noreferrer noopener'>
                {deal.cta}
              </TrackedAnchor>
            </span>
          </div>
        </div>
      ))}
    </div>
  );
};
